<template>
  <div class="hero" width="100%" height="auto">
    <video loop autoplay muted playsinline controls controlsList="nodownload" ref=video poster="../assets/sanpal-poster.png" width="100%" height="auto">
      <source ref="source" type="video/mp4">
      <track 
        default
        src="@/assets/vid-captions/bounce-buble.en.vtt"
        kind="captions"
        srclang="en"
        label="English CC"
      />
    </video>
    <!-- <div class="videoWrapper">
      <iframe width="100%" height="auto" src="https://www.youtube.com/embed/DU8m4CU4SbU?autoplay=1&mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'hero',
    mounted() {
      this.screenSize = '';      
      this.setVideoSrc();
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.setVideoSrc);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('scroll', this.setVideoSrc);
    },
    methods: {
      checkWidth(){
        if (window.innerWidth < 768){
          return 'mobile';
        } else {
          return 'desktop'
        }
      },
      setVideoSrc(){       

        let screenSize = this.checkWidth();

        // return if no breakpoint is crossed
        if (screenSize === this.screenSize) return;

        if (screenSize === 'mobile'){
          this.screenSize = 'mobile';
          this.$refs.source.setAttribute('src', 'static/videos/sang-pal-tvc-mobile.mp4');
          this.$refs.video.load();
        } else {
          this.screenSize = 'desktop';
          this.$refs.source.setAttribute('src', 'static/videos/sang-pal-tvc.mp4');
          this.$refs.video.load();
        }
      },
      isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
          rect.bottom >= 0 &&
          rect.top <= (window.innerHeight || html.clientHeight)
        );
      },
//      handleScroll() {
//        const video = this.$refs.video;
//
//        if (this.isInViewport(video)){
//          video.play();
//        } else {
//          var isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
//          if (isPlaying) {
//            video.pause();
//          }
//        }
//      } 
    }
  };
</script>

<style lang='scss' scoped>
  @import './../variables';

  .hero {
    font-size:0;

    // video {
    //   width: 100%;
    // }
    .videoWrapper {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      height: 0;
      overflow: hidden;
    }

    .videoWrapper iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue